<bw-action-article-legacy [brightsideWebFb]="{ event_name: 'kyc_intro' }">
  <div header-actions>
    <ui-nav-exit-back [trackingDetail]="{ event_name: 'kyc_intro' }" (exitActionHandler)="goHome()"></ui-nav-exit-back>
  </div>
  <div content-section>
    <div class="mb-sm">
      <img src="../assets/kyc-cameras.png" />
    </div>
    <div class="copy-wrapper">
      <typography-legacy title-medium class="mb-sm" color="var(--primary-text)">
        <div [innerHTML]="'KYC_INTRO_TITLE' | translate"></div>
      </typography-legacy>
      <typography-legacy text-medium-regular class="mb-md" color="var(--secondary-text)">
        <div [innerHTML]="'KYC_INTRO_DESC' | translate"></div>
      </typography-legacy>
      <typography-legacy text-xsmall-regular class="mb-md" color="var(--secondary-text)">
        <div [innerHTML]="'KYC_INTRO_INFO' | translate"></div>
      </typography-legacy>
    </div>
  </div>

  <div footer-actions>
    <div class="flex-row row-reverse">
      <button bw-button-legacy type="submit" (click)="showSocureModal()" [brightsideWebFb]="{ event_name: 'kyc_intro' }">
        {{ 'BUTTON_CONTINUE' | translate }}
      </button>
    </div>
  </div>
</bw-action-article-legacy>

<bw-modal-legacy
  *ngIf="showKycModal"
  [showCloseButton]="true"
  (closeModal)="showKycModal = false"
  modalWidth="large"
  [brightsideWebFb]="{ event_name: 'kyc_intro_modal' }"
>
  <div class="body">
    <bw-spinner-legacy *ngIf="showSpinner"></bw-spinner-legacy>
    <div id="socureDiv"></div>
  </div>
</bw-modal-legacy>

<bw-modal-legacy *ngIf="showVerifyingModal" modalWidth="medium">
  <div class="body center mb-sm">
    <bw-spinner-legacy></bw-spinner-legacy>
    <typography-legacy>{{ 'VERIFICATION_VALIDATING' | translate }}</typography-legacy>
  </div>
</bw-modal-legacy>
